import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM12 7.00903C11.503 7.00903 11.1 7.41198 11.1 7.90903C11.1 8.40609 11.503 8.80903 12 8.80903C12.4971 8.80903 12.9 8.40609 12.9 7.90903C12.9 7.41198 12.4971 7.00903 12 7.00903ZM12 16.8408C11.5858 16.8408 11.25 16.505 11.25 16.0908L11.25 11.1817C11.25 10.7675 11.5858 10.4317 12 10.4317C12.4142 10.4317 12.75 10.7675 12.75 11.1817V16.0908C12.75 16.505 12.4142 16.8408 12 16.8408Z',
                    fill: '#82869E',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const InforFilled = React.forwardRef(IconComponent);
InforFilled.displayName = 'InforFilled';

export { InforFilled };
